export const analytics_event={
  login:"Login",
  logOut:"Logout",
  signUp:"Sign Up",
  changePassword:"Change Password",
  pushNotification:"Push notification",
  MembershipBillingSelection:"Billing Selection",
  enrollmentToProgram:"Enrollment",
  exerciseCompleted:"Exercise Completed",
  courseCompleted:"Course Completed",
  programCompleted:"Program Completed",
  watchRecording:"Watch Recording",
  badgeEarned:"BadgeEarned",
  NoteCreated:"Note Created",
  conversationStarted:"Conversation started",
  replyToDiscussion:"Reply to discussion",
  bookmarkAdded:"Bookmark Added",
  WatchContent: (type: string) => `Watch ${type}`

}
export const analytics_category={
  buttonCLickLogin:"User Action",
  buttonClickLogOut:"User Action",
  buttonCliCkSignup:"Sign Up",
  buttonCliCkChangePassword:"Change Password",
  buttonClickPushNotifiction:"User Action",
  buttonClickMembershipBillingSelection:"Subscription",
  buttonClickEnrollmentToProgram:"Program Activity",
  buttonClickExerciseActivity:"Course Activity",
  buttonClickCourseActivity:"Course Activity",
  buttonClickProgramCompleted:"Program Activity",
  buttonclickWatchReacording:"Program Activity",
  buttonClickBadgeEarned:"Achievements",
  buttonClickCNoteCreated:"Content Creation",
  buttonClickConversationStarted:"Content Creation",
  buttonClickReplyToDiscussion:"Content Creation",
  buttonClickBookmarkAdded:"Content Interaction",
  buttonClickViewContent: "Program Activity"

}
export const analytics_label={
  loginLabel:"User Login",
  logOutLable:"User Logout",
  signUpLable:"7 Day Trial started",
  ChangePasswordLable:"Password Changed",
  pushNotificationsLable: (type: string) => `${type} push notifications`,
  membershipBillingSelectionLable:"Monthly vs. Annual",    
  enrollmentToProgramLable:"User Enrolled",
  exerciseFinishedLable:"Exercise Completion",
  CourseFinishedLable:"Course Finished",
  programFinishedLable:"Program Finished",
  watchRecordingLable:"Watch Recording",
  earnedBadgeLable:"User Earned Badge",
  noteCreatedLable:"User Created a Note",
  conversationStartedLable:"User Started Conversation",
  ReplyToDiscussionLable:"User Replied to a Discussion",
  bookmarkAddedLable:"User added bookmark",
  WatchContentLabel: (type: string) => `Watched ${type}`

}


export const analytics_items = {
    value: 99.99,
    currency: 'USD',
    transaction_id: '12345',
    items: [
      {
        item_name: 'T-shirt',
        item_id: '1234',
        quantity: 1,
        price: 19.99
      },
      {
        item_name: 'Jeans',
        item_id: '5678',
        quantity: 1,
        price: 39.99
      }
    ]
  };

  export const appcues_event={
    login:"User Logged In",
    logOut:"User Logout",
    signUp:"User Signed Up",
    profileCompleted:"Profile Completed",
    programJoined:"Program Joined",
    lessonStarted:"Lesson Started",
    lessonNoteAdded:"Lesson Note Added",
    lessonCompleted:"Lesson Completed",
    communityCommentPosted:"Community Comment Posted",
    userMentionedInComment: "User Mentioned In Comment",
    onlineEventJoined:"Online Event Joined",
    subscriptionCancelled: "Subscription Cancelled",
    weekComplete: "Week Complete",
    exerciseComplete: "Exercise Completed"
  }